import React from "react";
import { SolutionType } from "../store/slices/settingsSlice";

interface SolutionInfoPanelProps {
  solution?: SolutionType;
}

const formatDate = (value: any) => {
  if (!value) return "-";

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
};

const SolutionInfoPanel: React.FC<SolutionInfoPanelProps> = ({ solution }) => {
  const actionBreakdown = (solution as any)?.Info?.ActionBreakdownPerComponent;

  return (
    <div className="h-100 overflow-auto p-3 bg-light">
      <section className="mb-4">
        <h3 className="fw-bold fs-5">Solution</h3>
        <div className="p-3 rounded-3 bg-white border">
          <div>
            <span className="me-2 fw-bold">Solution Name:</span>
            <span>{solution?.Label || "-"}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Reference:</span>
            <span>{solution?.Reference || "-"}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Description:</span>
            <span>{solution?.Description || "-"}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Status:</span>
            <span>{(solution as any)?.Status || "-"}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Version:</span>
            <span>{solution?.Version || "-"}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Kind:</span>
            <span>{solution?.Kind || "-"}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Created at:</span>
            <span>{formatDate((solution as any)?.CreatedAt)}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Updated at:</span>
            <span>{formatDate((solution as any)?.UpdatedAt)}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Email:</span>
            <span>{(solution as any)?.Email || "-"}</span>
          </div>
        </div>
      </section>

      <section>
        <h3 className="fw-bold fs-5">Components</h3>
        {(solution?.Components || []).map((component: any, index: number) => {
          const workflows = Object.entries(
            actionBreakdown?.[component.ItemUuid] || {}
          ) as [string, any][];

          return (
            <div
              key={component.ComponentUuid || component.ItemUuid || index}
              className="p-3 rounded-3 bg-white border mb-2"
            >
              <div className="fw-bold">{component.Item?.Label || "Component"}</div>
              <div>{component.Description}</div>
              <div>
                <span className="me-2 fw-bold">Description:</span>
                <span>{component.Item?.Description || "-"}</span>
              </div>

              {workflows
                .slice()
                .sort(([, firstWorkflow], [, secondWorkflow]) =>
                  firstWorkflow.IsEntrypoint === secondWorkflow.IsEntrypoint
                    ? 0
                    : firstWorkflow.IsEntrypoint
                    ? -1
                    : 1
                )
                .map(([workflowKey, workflow]) => (
                  <div
                    key={workflowKey}
                    className={`mt-2 p-2 border rounded-2 position-relative ${
                      workflow.IsEntrypoint ? "border-danger" : ""
                    }`}
                  >
                    {workflow.IsEntrypoint && (
                      <div className="position-absolute top-0 end-0 m-1 badge rounded-pill bg-danger">
                        First workflow
                      </div>
                    )}
                    <div>
                      <span className="me-2 fw-bold">Workflow Name:</span>
                      <span>{workflow.WorkflowName || "-"}</span>
                    </div>
                    <div>
                      <span className="me-2 fw-bold">Number of actions:</span>
                      <span>{workflow.Total ?? 0}</span>
                    </div>
                    <div>
                      <span className="me-2 fw-bold">Can Repeat:</span>
                      <span>{workflow.CanRepeat ? "Yes" : "No"}</span>
                    </div>
                  </div>
                ))}
            </div>
          );
        })}
      </section>
    </div>
  );
};

export default SolutionInfoPanel;
